import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';

import { VersionDialogComponent } from './version-dialog.component';

export * from './version-dialog.component';

@NgModule({
    declarations: [
        VersionDialogComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
        MatTableModule,
    ],
    exports: [
        VersionDialogComponent,
    ]
})
export class VersionDialogModule { }
